import {
    type GetUploadTokenForNewsCoverResponseType,
    type GetUploadTokenForNewsCoverRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForNewsCover = async (params: GetUploadTokenForNewsCoverRequestType): Promise<GetUploadTokenForNewsCoverResponseType> => {
    return await request<GetUploadTokenForNewsCoverResponseType>("/news/getUploadTokenForNewsCover", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForNewsCover;
